module.exports = __webpack_public_path__ + "static/Country_Neighbors.5851e1ce.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/img/Country_Neighbors.mp4
// module id = 359
// module chunks = 35783957827783